import BCheckpanel from "../../modules/BCheckpanel";
import BApp from "../../modules/BApp";
import BForm from "../../modules/BForm";
import BRequest from "../../modules/BRequest";
import JPDatepicker from "../fo2026/JPDatepicker";

export default class BSalesProductSetupForm extends BForm
{
	static selector = () => `.b-sales-product-setup-form`;

	static initialize()
	{
		this.addEventListeners();
		document.querySelectorAll(this.selector()).forEach((el) => {
			(new this(el)).refreshExceptionWarnings();
		});
	}

	static addEventListeners()
	{
		document.addEventListener("submit", event => {
			if (event.target.matches(this.selector())) {
				event.preventDefault();

				const form = new this(event.target);
				form.getResult();
			}
		});

		document.addEventListener("click", event => {
			const selector = `${this.selector()}__submit-button`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				event.preventDefault();

				const form = new this(event.target.closest(this.selector()));
				form.getResult();
			}
		});

		document.addEventListener("change", event => {
			if (event.target.matches(`${this.selector()}__sport-durations [type="checkbox"]`)) {
				let checked = 0;
				document.querySelectorAll(`${this.selector()}__sport-duration`).forEach(el => {
					checked += el.checked ? 1 : 0;
				});

				document.querySelector(`${this.selector()}__sport-duration-none`).checked = (checked ? false : true);
				BApp.refresh();
				document.querySelectorAll(BCheckpanel.selector()).forEach(el => {
					new BCheckpanel(el).refreshState();
				});
			}
		});

		document.addEventListener("change", event => {
			if (event.target.matches(`[name="diagnosis_type"]`)) {
				(new this(event.target.closest(this.selector()))).refreshDiagnosisExceptionWarning();
			}
		});

		document.addEventListener("change", event => {
			if (event.target.matches(`[name="maternity_scenario"]`)) {
				(new this(event.target.closest(this.selector()))).refreshMaternityExceptionWarning();
			}
		});

		/**************************************************************************
		 * Children.
		 */
		document.addEventListener("click", event => {
			const selector = `${this.selector()}__add-child-button`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				const form = new this(event.target.closest(this.selector()));
				const el = form.el.querySelector(`${this.selector()}__child-template`).content.cloneNode(true);

				form.el.querySelector(`${this.selector()}__children`).appendChild(el);

				form.refreshChildren();
				form.el.querySelectorAll(JPDatepicker.selector()).forEach((datepickerEl) => {
					JPDatepicker.initializeElement(datepickerEl);
				});
				BApp.refresh();
			}
		});

		document.addEventListener("click", event => {
			const selector = `${this.selector()}__remove-child-button`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				const form = new this(event.target.closest(this.selector()));
				const el = event.target.closest(`${this.selector()}__child`);

				el.remove();

				form.refreshChildren();
				BApp.refresh();
			}
		});
	}

	refreshExceptionWarnings()
	{
		this.refreshDiagnosisExceptionWarning();
		this.refreshMaternityExceptionWarning();

		return this;
	}

	refreshDiagnosisExceptionWarning()
	{
		const input = this.el.querySelector(`[name="diagnosis_type"]`);
		if (!input) {
			return this;
		}

		this.toggleExceptionWarning(input.closest(`.b-box`), ["iddm", "iddm_lada", "gdm"].includes(input.value));

		return this;
	}

	refreshMaternityExceptionWarning()
	{
		const input = this.el.querySelector(`[name="maternity_scenario"]:checked`);
		if (!input) {
			return this;
		}

		this.toggleExceptionWarning(input.closest(`.b-box`), ["pregnant", "breastfeeding"].includes(input.value));

		return this;
	}

	toggleExceptionWarning(box, isVisible)
	{
		if (!box) {
			return this;
		}

		box.querySelectorAll(`${BSalesProductSetupForm.selector()}__diagnosis-exception-warning`).forEach((el) => {
			el.hidden = !isVisible;
		});

		return this;
	}

	refreshChildren()
	{
		this.el.querySelector(`${BSalesProductSetupForm.selector()}__children`).querySelectorAll(`${BSalesProductSetupForm.selector()}__child`).forEach((child, index) => {
			child.querySelectorAll(`[data-for-template]`).forEach(el => {
				el.setAttribute("for", el.dataset.forTemplate.replace("%index%", index));
			});
			child.querySelectorAll(`[data-id-template]`).forEach(el => {
				el.setAttribute("id", el.dataset.idTemplate.replace("%index%", index));
			});
			child.querySelectorAll(`[data-name-template]`).forEach(el => {
				el.setAttribute("name", el.dataset.nameTemplate.replace("%index%", index));
			});
			child.querySelectorAll(`[data-dataset-name-template]`).forEach(el => {
				el.dataset.name = el.dataset.datasetNameTemplate.replace("%index%", index);
			});
		});
	}

	getResult()
	{
		const url = this.getURL();
		const data = this.getData();

		data.agreementResponses = [];
		this.el.querySelectorAll(`[data-agreement-version-id]`).forEach(el => {
			data.agreementResponses.push({
				agreementVersion: { id: parseInt(el.dataset.agreementVersionId, 10) },
				isGranted: !!el.checked,
			});
		});

		this.resetErrors();
		this.disable();

		BRequest.post(url, data).then(response => {
			if (response.data?.redirectUrl) {
				BApp.redirect(response.data.redirectUrl);
			}
		}).catch(error => {
			this.setErrorResponse(error.response);
		}).finally(() => {
			this.enable();
		});
	}
}
